import { z } from 'zod';

export const getSessionsDetailsSchema = z.object({
  aliveTime: z.string().time(),
  applicationUserID: z.string(),
  companyID: z.string(),
  companySiteID: z.string(),
  dbName: z.string(),
  fullName: z.string(),
  id: z.string(),
  isAdmin: z.boolean(),
  isMobile: z.boolean(),
  lastAlive: z.string().datetime({ offset: true }),
  loginTime: z.string().datetime({ offset: true }),
  requests: z.number(),
  roleIDs: z.array(z.string()),
  salesPersonID: z.string().nullish(),
  salt: z.string(),
  topRows: z.number(),
  userID: z.string(),
  userName: z.string(),
  userType: z.string(),
  wrHouseID: z.string(),
});

export type GetSessionDetailsResponse = z.infer<typeof getSessionsDetailsSchema>;
